import { Button, GridLegacy as Grid } from "@mui/material";
import { useTracking } from "react-tracking";
import { Link, useRouteMatch } from "@/compat/router";
import CardBase from "../../../components/cards/CardBase";
import TemplatesTableCard from "../../components/MonitoringAdminTemplatesTableCard";
import PageBase from "../../../components/PageBase";
import PageTitle from "../../components/PageTitle";
import { Visibility } from "@mui/icons-material";
import { useAppSelector } from "@/redux/hooks";
import { useAuth } from "../../../contexts/authContext";
import RequiresRoleWrapper from "../../../components/RequiresRoleWrapper";

function MonitoringAdmin() {
  const { Track } = useTracking({
    page: `Admin: Monitoring`,
  });
  const match = useRouteMatch();
  const { selectedAccount } = useAppSelector((state) => state.account);
  const { isTemplateAdminForSites, isWorknestUser } = useAuth();
  const { path } = match;

  const isTemplateAdmin = isTemplateAdminForSites(
    selectedAccount?.childExternalIds
  );

  return (
    <RequiresRoleWrapper hasRole={isTemplateAdmin || isWorknestUser}>
      <PageBase>
        <Track>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CardBase
                title={
                  <PageTitle icon={<Visibility />} title="Monitoring Setup" />
                }
                rightComponent={
                  <Button
                    component={Link}
                    to={`${path}/templatebuilder`}
                    variant="contained"
                    color="primary"
                  >
                    Create Template
                  </Button>
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TemplatesTableCard />
            </Grid>
          </Grid>
        </Track>
      </PageBase>
    </RequiresRoleWrapper>
  );
}

export default MonitoringAdmin;
